// Category hierarchy and rules for resource upload form

export const categoryStructure = {
  "ESI": {
    subCategories1: ["Circulars - PDF", "Benefits - Link"],
    locationRules: { type: "All India", showDropdown: false }
  },
  "PF": {
    subCategories1: ["Circulars - PDF", "International Workers - Link"],
    locationRules: { type: "All India", showDropdown: false }
  },
  "Labour Code": {
    subCategories1: [
      "Code on Wages",
      "Occupational Safety, Health & Working Condition Code",
      "Social Security Code",
      "Industrial Relations Code"
    ],
    subCategories2: {
      "Code on Wages": ["Central Act", "Central Rules", "State Rules"],
      "Occupational Safety, Health & Working Condition Code": ["Central Act", "Central Rules", "State Rules"],
      "Social Security Code": ["Central Act", "Central Rules", "State Rules"],
      "Industrial Relations Code": ["Central Act", "Central Rules", "State Rules"]
    },
    locationRules: {
      "Central Act": { type: "All India", showDropdown: false },
      "Central Rules": { type: "All India", showDropdown: false },
      "State Rules": { type: "All India", showDropdown: false }
    }
  },
  "Registers": {
    subCategories1: ["Establishment", "State", "Month"],
    locationRules: {
      "Establishment": { type: "Multiple", showDropdown: true, options: ["Central", "State", "Union Territory"] },
      "State": { type: "Multiple", showDropdown: true, options: ["State", "Union Territory"] },
      "Month": { type: "All India", showDropdown: false }
    }
  },
  "Returns": {
    subCategories1: ["Establishment", "State", "Month", "Due date"],
    locationRules: {
      "Establishment": { type: "Multiple", showDropdown: true, options: ["Central", "State", "Union Territory"] },
      "State": { type: "Multiple", showDropdown: true, options: ["State", "Union Territory"] },
      "Month": { type: "All India", showDropdown: false },
      "Due date": { type: "All India", showDropdown: false }
    }
  },
  "Minimum Wages": {
    subCategories1: ["National Floor Wages"],
    locationRules: {
      "National Floor Wages": { type: "Multiple", showDropdown: true, options: ["State", "Union Territory"] }
    }
  },
  "Professional Tax": {
    subCategories1: [],
    locationRules: { type: "Union Territory", showDropdown: true }
  },
  "Gazette Notifications": {
    subCategories1: ["State", "Holiday", "Labour Code / Act", "Others"],
    locationRules: {
      "State": { type: "Multiple", showDropdown: true, options: ["State", "Union Territory"] },
      "Holiday": { type: "Multiple", showDropdown: true, options: ["Central", "State", "Union Territory"] },
      "Labour Code / Act": { type: "Multiple", showDropdown: true, options: ["Central", "State", "Union Territory"] },
      "Others": { type: "Multiple", showDropdown: true, options: ["Central", "State", "Union Territory"] }
    }
  },
  "POSH": {
    subCategories1: [],
    locationRules: { type: "All India", showDropdown: false }
  },
  "Leave": {
    subCategories1: ["Establishment", "State"],
    locationRules: {
      "Establishment": { type: "Multiple", showDropdown: true, options: ["Central", "State", "Union Territory"] },
      "State": { type: "Multiple", showDropdown: true, options: ["State", "Union Territory"] }
    }
  },
  "N&F Holidays": {
    subCategories1: ["Establishment", "State"],
    locationRules: {
      "Establishment": { type: "Multiple", showDropdown: true, options: ["Central", "State", "Union Territory"] },
      "State": { type: "Multiple", showDropdown: true, options: ["State", "Union Territory"] }
    }
  }
};

export const indianStates = [
  "Andhra Pradesh", "Arunachal Pradesh", "Assam", "Bihar", "Chhattisgarh",
  "Goa", "Gujarat", "Haryana", "Himachal Pradesh", "Jharkhand", "Karnataka",
  "Kerala", "Madhya Pradesh", "Maharashtra", "Manipur", "Meghalaya", "Mizoram",
  "Nagaland", "Odisha", "Punjab", "Rajasthan", "Sikkim", "Tamil Nadu",
  "Telangana", "Tripura", "Uttar Pradesh", "Uttarakhand", "West Bengal"
];

export const unionTerritories = [
  "Andaman & Nicobar Islands",
  "Chandigarh",
  "Dadra & Nagar Haveli and Daman & Diu",
  "Delhi",
  "Jammu & Kashmir",
  "Ladakh",
  "Lakshadweep",
  "Puducherry"
];

// Combined list for Applicability dropdown (replaces old "Industry")
export const applicabilityOptions = [
  "All Industries",
  "All Scheduled Employments",
  "All Establishments",
  "All Workers",
  ...indianStates,
  ...unionTerritories
];

export const impactLevels = ["High", "Medium", "Low"];

// Auto-determine location based on selections
export function determineLocation(category, subCategory1, subCategory2) {
  const structure = categoryStructure[category];
  if (!structure) return { type: "All India", showDropdown: false };

  const locationRules = structure.locationRules;
  
  // Check specific rules with exact key matching
  const key1 = `${subCategory1} - ${subCategory2}`;
  const key2 = subCategory2;
  const key3 = subCategory1;
  
  if (subCategory2 && locationRules[key1]) {
    return locationRules[key1];
  }
  
  if (subCategory2 && locationRules[key2]) {
    return locationRules[key2];
  }
  
  if (subCategory1 && locationRules[key3]) {
    return locationRules[key3];
  }
  
  if (locationRules.default) {
    return locationRules.default;
  }
  
  return locationRules;
}

// Get specific location options based on location type and rules
export function getLocationOptions(locationType, locationRule = null) {
  // If specific options are provided in the rule, use those
  if (locationRule && locationRule.options) {
    let options = [];
    if (locationRule.options.includes("Central")) {
      options.push("Central");
    }
    if (locationRule.options.includes("State")) {
      options.push(...indianStates);
    }
    if (locationRule.options.includes("Union Territory")) {
      options.push(...unionTerritories);
    }
    return options;
  }
  
  // Otherwise use standard location type mapping
  switch (locationType) {
    case "Central":
      return ["Central"];
    case "State":
      return indianStates;
    case "Union Territory":
      return unionTerritories;
    case "Multiple":
      return ["Central", ...indianStates, ...unionTerritories];
    default:
      return [];
  }
}

